import React, { useState } from 'react';
import { Input } from './input';

const formatSSN = (value) => {
  const digits = value.replace(/\D/g, '').slice(0, 9);
  if (digits.length <= 3) return digits;
  if (digits.length <= 5) return `${digits.slice(0, 3)}-${digits.slice(3)}`;
  return `${digits.slice(0, 3)}-${digits.slice(3, 5)}-${digits.slice(5)}`;
};

const formatEIN = (value) => {
  const digits = value.replace(/\D/g, '').slice(0, 9);
  if (digits.length <= 2) return digits;
  return `${digits.slice(0, 2)}-${digits.slice(2)}`;
};

const maskValue = (val, maskPattern) => {
  if (!val || val.length === 0) return '';

  if (maskPattern === 'ssn') {
    const digits = val.replace(/\D/g, '');
    if (digits.length <= 4) return val;
    const last4 = digits.slice(-4);
    return `•••-••-${last4}`;
  }

  if (maskPattern === 'ein') {
    const digits = val.replace(/\D/g, '');
    if (digits.length <= 4) return val;
    const last4 = digits.slice(-4);
    return `••-•••${last4}`;
  }

  if (val.length <= 4) return val;
  const last4 = val.slice(-4);
  return '•'.repeat(val.length - 4) + last4;
};

const MaskedInput = ({ value, onChange, maskPattern, className, ...props }) => {
  const [isFocused, setIsFocused] = useState(false);

  const handleChange = (e) => {
    let newValue = e.target.value;

    if (maskPattern === 'ssn') {
      newValue = formatSSN(newValue);
    } else if (maskPattern === 'ein') {
      newValue = formatEIN(newValue);
    }

    onChange({ ...e, target: { ...e.target, value: newValue } });
  };

  const displayValue = isFocused ? (value || '') : maskValue(value || '', maskPattern);

  return (
    <Input
      {...props}
      className={className}
      value={displayValue}
      onChange={handleChange}
      onFocus={() => setIsFocused(true)}
      onBlur={() => setIsFocused(false)}
    />
  );
};

export default MaskedInput;
